import { VehicleFuelType } from '@api/index';
import { getSelectedFuelTypes } from '@features/tree/selectors';
import { DriverFuelType } from '@pages/driverAnalysis/driverAnalysisReducer';
import { getSelectedFuelType as getDriverSelectedFuelType } from '@pages/driverAnalysis/driverAnalysisSelectors';
import { useSelector } from 'react-redux';

const mapFleetSelectedFuelTypesToDriverFuelType = (selectedFuelTypes: VehicleFuelType[]): DriverFuelType => {
    if (!selectedFuelTypes.length) {
        return DriverFuelType.ALL;
    }

    if (selectedFuelTypes.length > 1) {
        return DriverFuelType.ALL;
    }

    if (selectedFuelTypes[0] === VehicleFuelType.ELECTRIC) {
        return DriverFuelType.ELECTRIC;
    }

    return DriverFuelType.FUEL;
};

export default function useAnalysisSelectedFuelType(location: string): { selectedFuelType: DriverFuelType } {
    const driverSelectedFuelType = useSelector(getDriverSelectedFuelType);
    const fleetSelectedFuelTypes = useSelector(getSelectedFuelTypes);

    if (location === 'drivingAnalysis') {
        return { selectedFuelType: driverSelectedFuelType };
    }

    return {
        selectedFuelType: mapFleetSelectedFuelTypesToDriverFuelType(fleetSelectedFuelTypes),
    };
}
